/**
 * Our complete color palette.
 * Please use this palete IF AND ONLY IF
 * the themes you are using does not contain the color you need.
 * @see [Documentation](https://zeroheight.com/85877f0ae/p/72b29d-universe)
 */
export var universe = Object.freeze({
  // Universe moonlight
  moonlight0: '#FFFFFF',
  moonlight10: '#F8F9FC',
  moonlight20: '#EEF0F7',
  moonlight30: '#D1D8DF',
  moonlight40: '#AFBCC6',
  moonlight50: '#81919C',
  moonlight60: '#63727C',
  moonlight70: '#4A5760',
  moonlight80: '#333C42',
  moonlight90: '#191E23',
  moonlight100: '#0C0F12',
  // Universe stardust
  stardust10: '#FFF9E4',
  stardust20: '#FFF1C1',
  stardust30: '#FFE99E',
  stardust40: '#FCD963',
  stardust50: '#F8CA2D',
  stardust60: '#F2BB00',
  stardust70: '#DAA800',
  stardust80: '#B58B00',
  stardust90: '#876800',
  stardust100: '#5D4700',
  // Universe borealis
  borealis10: '#F2FFEE',
  borealis20: '#CFFAC2',
  borealis30: '#B5F4A2',
  borealis40: '#8DDD74',
  borealis50: '#68C74A',
  borealis60: '#29AC00',
  borealis70: '#098300',
  borealis80: '#196700',
  borealis90: '#104500',
  borealis100: '#112D0C',
  // Universe earth
  earth10: '#E5EDFF',
  earth20: '#BCD4FF',
  earth30: '#8FB4FF',
  earth40: '#78A0FF',
  earth50: '#437EFF',
  earth60: '#2969FF',
  earth70: '#1954E0',
  earth80: '#0F43BC',
  earth90: '#093394',
  earth100: '#06246B',
  // Universe nebula
  nebula10: '#F3E6FF',
  nebula20: '#E5C5FF',
  nebula30: '#D9AAFF',
  nebula40: '#C27AFF',
  nebula50: '#AB4FFF',
  nebula60: '#7B0AF3',
  nebula70: '#710DD7',
  nebula80: '#620FB6',
  nebula90: '#561599',
  nebula100: '#330561',
  // Universe mars
  mars10: '#FFECEE',
  mars20: '#FFD1D6',
  mars30: '#FFB5BD',
  mars40: '#FF8492',
  mars50: '#FD596B',
  mars60: '#EA172F',
  mars70: '#D11328',
  mars80: '#B21324',
  mars90: '#8F1320',
  mars100: '#6B121B'
});
/**
 * @deprecated These colors are going to be deprecated in favor of a new Theme for nvio
 **/

export var nvioLegacy = Object.freeze({
  evergreen: '#08293c',
  marineBlue: '#003755'
});